import { Row } from 'antd'
import './ReportFooter.style.less'
import logo from '../../../../../assets/images/Fingertip_logo.svg'
function ReportFooter() {
  return (
    <Row
      className="report-footer-container"
      justify={'space-between'}
      align="middle"
    >
      <img src={logo} />
      <p>Powered by Fingertip</p>
    </Row>
  )
}

export default ReportFooter
